<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Logs de Ações
          </h4>

          <div class="col-12">
            <div class="row">
              <el-select
                class="col-12 col-sm-2 select-success mb-3 pagination-select"
                v-model="pagination.perPage"
                @change="listarLogs(1)"
                placeholder="Por página"
              >
                <el-option
                  v-for="item in perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>

              <el-select
                class="col-12 col-sm-2 select-success mb-3"
                v-model="filtros.modulo"
                clearable
                placeholder="Módulo"
                @change="listarLogs(1)"
              >
                <el-option
                  v-for="item in modulos"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>

              <el-select
                class="col-12 col-sm-2 select-success mb-3"
                v-model="filtros.acao"
                clearable
                placeholder="Ação"
                @change="listarLogs(1)"
              >
                <el-option
                  v-for="item in acoes"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>

              <el-select
                class="col-12 col-sm-2 select-success mb-3"
                v-model="filtros.tipoActor"
                clearable
                placeholder="Tipo usuário"
                @change="listarLogs(1)"
              >
                <el-option label="RH" value="RH" />
                <el-option label="ADMIN" value="ADMIN" />
              </el-select>

              <base-input class="col-12 col-sm-2">
                <el-input
                  v-model="filtros.idUsuarioRh"
                  clearable
                  placeholder="ID Usuário RH"
                />
              </base-input>

              <base-input class="col-12 col-sm-2">
                <el-input
                  v-model="filtros.idUsuarioAdmin"
                  clearable
                  placeholder="ID Admin"
                />
              </base-input>

              <base-input class="col-12 col-sm-2">
                <el-input
                  type="date"
                  v-model="filtros.dataInicio"
                  placeholder="Data início"
                />
              </base-input>

              <base-input class="col-12 col-sm-2">
                <el-input
                  type="date"
                  v-model="filtros.dataFim"
                  placeholder="Data fim"
                />
              </base-input>

              <div class="col-12 col-sm-4 mb-3">
                <base-button type="success" @click="listarLogs(1)">
                  Filtrar
                </base-button>

                <base-button type="default" @click="limparFiltros">
                  Limpar
                </base-button>
              </div>
            </div>
          </div>

          <el-table :data="logs">
            <el-table-column
              prop="id_actor"
              label="ID Usuário"
              min-width="80"
            />
            <el-table-column
              prop="nome_empregado"
              label="Usuário"
              min-width="120"
            />
            <el-table-column prop="acao" label="Ação" min-width="130" />
            <el-table-column prop="modulo" label="Módulo" min-width="170" />
            <el-table-column
              prop="id_registro_afetado"
              label="Registro"
              min-width="120"
            />
            <el-table-column
              prop="descricao"
              label="Descrição"
              min-width="300"
            />
            <el-table-column prop="data" label="Data" min-width="110" />
            <el-table-column prop="hora" label="Hora" min-width="100" />

            <el-table-column label="Ações" min-width="120" align="right">
              <div slot-scope="props">
                <base-button
                  class="btn-link"
                  type="info"
                  size="sm"
                  icon
                  @click.native="visualizarLog(props.row)"
                >
                  <i class="tim-icons icon-notes"></i>
                </base-button>
              </div>
            </el-table-column>
          </el-table>

          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div>
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} logs.
              </p>
            </div>

            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.totalItems"
              @input="listarLogs"
            />
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="dialogLog">
      <template slot="header">
        <h4 class="modal-title">Detalhes do Log</h4>
      </template>

      <div class="text-left" v-if="logSelecionado">
        <p><b>ID:</b> {{ logSelecionado.id }}</p>
        <p>
          <b>Usuário:</b> {{ logSelecionado.tipo_actor }} -
          {{ logSelecionado.id_actor }}
        </p>
        <p><b>Ação:</b> {{ logSelecionado.acao }}</p>
        <p><b>Módulo:</b> {{ logSelecionado.modulo }}</p>
        <p><b>Registro afetado:</b> {{ logSelecionado.id_registro_afetado }}</p>
        <p><b>Descrição:</b> {{ logSelecionado.descricao }}</p>
        <p>
          <b>Data/Hora:</b> {{ logSelecionado.data }} {{ logSelecionado.hora }}
        </p>

        <hr />

        <p><b>Dados anteriores:</b></p>
        <pre>{{ formatarJson(logSelecionado.dados_anteriores) }}</pre>

        <p><b>Dados novos:</b></p>
        <pre>{{ formatarJson(logSelecionado.dados_novos) }}</pre>

        <p><b>Filtros:</b></p>
        <pre>{{ formatarJson(logSelecionado.filtros) }}</pre>
      </div>
    </modal>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      />
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import Modal from "@/components/Modal.vue";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading,
    Modal,
    BasePagination,
    BaseInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      return this.total < highBound ? this.total : highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.totalItems;
    },
  },

  data() {
    return {
      isLoading: false,
      logs: [],
      dialogLog: false,
      logSelecionado: null,

      perPageOptions: [10, 50, 100],
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalItems: 0,
        totalPages: 0,
      },

      filtros: {
        modulo: "",
        acao: "",
        tipoActor: "",
        idUsuarioRh: "",
        idUsuarioAdmin: "",
        dataInicio: "",
        dataFim: "",
      },

      acoes: ["VISUALIZAR", "CRIAR", "EDITAR", "EXCLUIR"],
      modulos: [
        "ABONO",
        "TIPO ABONO",
        "ABONO DE HORA",
        "FOLGA",
        "AFASTAMENTO",
        "FERIADO",
        "BATIDA MANUAL",
        "OCORRENCIA",
        "ESCALA MENSAL",
        "ESCALA DEPARTAMENTO",
        "FUNCIONARIO",
        "EMPRESA",
        "USUARIO",
        "DEMISSAO",
        "GESTAO",
        // "FUNCAO",
        "HOLERITE",
        "HORA LIMITE DIA",
        "PARAMETRIZACAO",
        "RELATORIO",
        "ASSINATURA",
        "CARTAO DE PONTO",
      ],
    };
  },

  mounted() {
    this.listarLogs(1);
  },

  methods: {
    async listarLogs(page = 1) {
      this.isLoading = true;

      const query = {};

      Object.keys(this.filtros).forEach((key) => {
        if (this.filtros[key]) {
          query[key] = this.filtros[key];
        }
      });

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        page,
        limit: this.pagination.perPage,
        query,
      };

      try {
        const response = await this.axios.post(
          "/api/logs/listarLogAcao",
          bodyFormData,
        );

        const data = response.data.data;

        this.logs = data.logs || [];
        this.pagination = data.pagination;
      } catch (err) {
        console.log(err);
        swal({
          title: "Erro",
          text: "Erro ao listar logs de ações!",
          type: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      } finally {
        this.isLoading = false;
      }
    },

    limparFiltros() {
      this.filtros = {
        modulo: "",
        acao: "",
        tipoActor: "",
        idUsuarioRh: "",
        idUsuarioAdmin: "",
        dataInicio: "",
        dataFim: "",
      };

      this.listarLogs(1);
    },

    visualizarLog(row) {
      this.logSelecionado = row;
      this.dialogLog = true;
    },

    formatarJson(valor) {
      if (!valor) return "";

      try {
        if (typeof valor === "string") {
          return JSON.stringify(JSON.parse(valor), null, 2);
        }

        return JSON.stringify(valor, null, 2);
      } catch (err) {
        return valor;
      }
    },
  },
};
</script>

<style>
pre {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 6px;
  max-height: 250px;
  overflow: auto;
  white-space: pre-wrap;
  color: #333;
}
</style>
